import { SelectionBox, SelectionBoxItem } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  padding: 5.6rem 4rem 4rem 4rem;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex-grow: 1;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 3.2rem 1.6rem;
    gap: 1.6rem;
  }
`;

export const StyledContentContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem 6rem 4rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
    padding: 0;
  }
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.title};
  }
`;

export const StyledSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
`;

export const StyledSelectionBox = styled(SelectionBox)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
    gap: 1.6rem;
  }
`;

export const StyledSelectionBoxItem = styled(SelectionBoxItem)<{
  iconPosition?: 'top' | 'left';
  iconSize?: string;
}>`
  & > label {
    display: flex;
    gap: 1rem;
    height: 13.6rem;
    flex-direction: ${({ iconPosition }) => (iconPosition === 'left' ? 'row' : 'column')};
  }

  & > label > svg {
    margin-top: 0;
    height: 1.6rem; /* Decreased from 2rem to 1.6rem */
  }

  & + label > span + span {
    font-size: 1.1rem;
    line-height: 1.8rem;
  }
`;
